import React from 'react';
import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled(({ disabled, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 59" {...rest}>
    <path
      className="shield"
      d="M27.0527346,0.287610931 C34.3377675,7.14794939 43.9065585,10.4543321 53.815428,12.8392936 C53.3451375,34.5404013 43.9280955,52.637204 26.9824221,58.596204 C18.1565878,55.7151886 11.4919825,49.6567555 6.9873048,41.4085555 C2.5986411,33.3732079 0.4180941,23.3393503 0.1845702,12.901343 C10.6014946,11.3047122 19.9052518,7.54188785 27.0527346,0.287610931 Z M39.014649,19.7178994 L22.6054687,34.2019737 L15.0908202,26.6319619 L11.9091798,29.8407958 L22.3945312,40.415767 L41.985351,23.1306096 L39.014649,19.7178994 Z"></path>
  </svg>
))`
  width: 54px;

  .shield {
    fill: ${({ color, disabled }) => (color ? color : disabled ? lightGrey2Color : '#FEC141')};
  }
`;
